import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import './InspectionMethod.css';
import { Box, Grid, Card, CardContent, Typography, Button } from '@mui/material';
import StepIndicator from "./StepIndicator";
import { useSelector, useDispatch } from "react-redux";
import { setLoading } from "../../store/feedback";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    LinearProgress,
    Tooltip
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Support from '../../contact-popup-module/Support';
import moment from 'moment';
import ShareAuditOptions from './ShareAuditOptions';
const InspectionMethod = () => {
    const share = `${process.env.PUBLIC_URL}/custom-icons/share.svg`;
    const tick = `${process.env.PUBLIC_URL}/custom-icons/white-tick.png`;
    const copy = `${process.env.PUBLIC_URL}/custom-icons/pink-copy-icon.png`;
    const [dialogWidth, setDialogWidth] = useState("29vw");
    const { audit_id } = useParams();
    const [reqUrl, setReqUrl] = useState(null);
    const [dialogSeverity, setDialogSeverity] = useState("success");
    const [isCopied, setIsCopied] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const query_icon = `${process.env.PUBLIC_URL}/custom-icons/query.png`;
    const arrow_icon = `${process.env.PUBLIC_URL}/custom-icons/arrow-next.png`;
    const clock_icon = `${process.env.PUBLIC_URL}/custom-icons/clock.png`;
    const navigate = useNavigate();

    // State to check if the current time is between 10 am and 6 pm
    const [isAvailable, setIsAvailable] = useState(false);
    const dispatch = useDispatch();
    const showAlert = (severity, message) => {
        setDialogSeverity(severity);
        setOpenDialog(true);
    };
    const handleDialogClose = event => {
        // if (
        //   event.target.tagName.toLowerCase() !== "button" &&
        //   !event.target.closest("button")
        // ) {

        //   return;
        // }
        setOpenDialog(false);
    };
    const [dialogText, setDialogText] = useState("0.9rem");
    useEffect(() => {
        const handleResize = () => {
            const windowWidth = window.innerWidth;
            if (windowWidth <= 450) {
                setDialogWidth("94vw");
            } else if (windowWidth <= 475) {
                setDialogWidth("94vw");
            } else if (windowWidth <= 570) {
            } else if (windowWidth <= 575) {
                setDialogText("0.6rem");
                setDialogWidth("64vw");
            } else if (windowWidth <= 650) {
                setDialogWidth("60vw");
            } else if (windowWidth <= 700) {
            } else if (window.innerWidth <= 775) {
                setDialogWidth("57vw");
            } else if (window.innerWidth <= 875) {
                setDialogWidth("55vw");
            } else if (windowWidth <= 1000) {
                setDialogWidth("48vw");
            } else if (window.innerWidth <= 1100) {
                setDialogWidth("45vw");
                setDialogText("0.8rem");
            } else if (windowWidth <= 1300) {
                setDialogWidth("40vw");
            } else {
                setDialogWidth("35vw");
            }
        };

        window.addEventListener("resize", handleResize);

        handleResize();

        // Cleanup function to remove event listener
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const handleCopy = () => {
        setIsCopied(true)
        navigator.clipboard.writeText(reqUrl)
            .then(() => {
                setIsCopied(true);
                toast.success("Link Copied!", {
                    position: "bottom-center",
                    autoClose: 1000,
                    type: "default",
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    className: "custom-toast",
                });
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };

    const onFinish = async () => {
        // const audit = generateRandomId();
        console.log(audit_id,);
        try {
            dispatch(setLoading(true));
            const res = await axios.post("/create_audit/get_token", {
                auditID: audit_id,
                mode: selectedMethod,
                lead_creation_time: moment().format("DD-MM-YYYY HH:mm")
            });
            // try{
            //     const res = await axios.post("/create_audit/add_mode",{audit:audit_id,mode:method})
            //     console.log(res.data);
            //  }
            //  catch(err){
            //      console.log(err)
            //  }
            const hostname = window.location.hostname;
            const port = window.location.port;
            let baseURL;
            if (port !== "") {
                baseURL = `https://${hostname}:${port}`;

            }
            else {
                baseURL = `https://${hostname}`;
            }
            const url = `${baseURL}/audit/${selectedMethod}/permission/${audit_id}`;
            setReqUrl(url);
            setOpenDialog(true);
            console.log(url, "121");

            showAlert("success", "Audit created successfully");
            dispatch(setLoading(false));
        } catch (err) {
            console.log(err);
            dispatch(setLoading(false));
        }
    };
    useEffect(() => {
        const checkAvailability = () => {
            const currentHour = new Date().getHours();
            setIsAvailable(currentHour >= 9 && currentHour < 18);
        };

        checkAvailability();
        // Optionally, add a timer to check time every minute if needed
        const timer = setInterval(checkAvailability, 60000);
        return () => clearInterval(timer);
    }, []);

    const handleNavigate = () => {
        window.location.href = reqUrl;
    };
    const [selectedMethod, setSelectedMethod] = useState(null);

    const handleCardClick = (method) => {
        console.log(method);
        setSelectedMethod(method);
        // You can also open a dialog or do other actions here
        // setOpenDialog(true);
    };
    const handleCombinedClick = async (method) => {
        console.log(method, "186")
        handleCardClick(method);  // Call handleClick function
        //     // Call onFinish function

    };
    const handleConfirm = () => {
        onFinish();
    }
    const renderCard = (title, description, disabled, method) => (
        <Card
            sx={{
                height: "135px",
                mb: 1,

                borderRadius: 2,
                boxShadow: 2,
                border: '1px solid #e0e0e0',
                opacity: disabled ? 0.5 : 1,
                pointerEvents: disabled ? 'none' : 'auto', // Disable interactions when card is disabled
                position: 'relative', // For positioning the availability label
            }}
        >
            <CardContent sx={{ padding: "5px 10px", margin: "0.1rem" }}>
                <Grid container alignItems="center" marginTop='6px'>
                    <Grid item xs={8}>
                        <Typography
                            variant="h6"
                            fontWeight="bold"
                            fontFamily="Montserrat, sans-serif"
                            sx={{
                                fontSize: '15px',
                                mb: 0,
                            }}
                        >
                            {title}
                        </Typography>
                    </Grid>
                    <Grid item xs={4} sx={{ textAlign: 'right' }}>
                        <img
                            src={clock_icon}
                            alt="clock icon"
                            style={{
                                width: '14px',
                                height: '14px',
                                verticalAlign: 'middle',
                                marginRight: '3px',
                                color: '#999999',
                            }}
                        />
                        <Typography
                            variant="caption"
                            color="textSecondary"
                            fontFamily="Montserrat, sans-serif"
                            sx={{ fontSize: '12px' }}
                        >
                            Approx. 10m
                        </Typography>
                    </Grid>
                </Grid>

                <Typography
                    variant="body2"
                    color="textSecondary"
                    fontFamily="Montserrat, sans-serif"
                    sx={{
                        mt: 0.5,
                        mb: 0.5,
                        lineHeight: 1.3,
                        fontSize: '13px',
                    }}
                >
                    {description}
                </Typography>
                {/* 
                <Grid container spacing={1} alignItems="center" sx={{ mb: 1 }}>
                    <Grid item xs={8}>
                        <Typography
                            variant="caption"
                            color="#9E9E9E"
                            fontFamily="Roboto"
                            sx={{ fontSize: '12px' }}
                        >
                            Requirement
                        </Typography>
                    </Grid>
                    <Grid item xs={4} sx={{ textAlign: 'right' }}>
                        <Typography
                            variant="caption"
                            color="#9E9E9E"
                            fontFamily="Roboto"
                            sx={{ fontSize: '12px' }}
                        >
                            Camera xxx
                            
                        </Typography>
                    </Grid>
                </Grid> */}


                {disabled && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)', // Centers the box
                            backgroundColor: '#333', // Dark background to match the label in the image
                            color: '#fff',
                            borderRadius: '12px',
                            padding: '4px 12px', // Adjust padding for better visibility
                            fontSize: '12px', // Slightly larger font size for readability
                            fontFamily: 'Montserrat, sans-serif',
                            zIndex: 10, // Ensure the label is on top of other elements
                            textAlign: 'center', // Center the text within the box
                        }}
                    >
                        Available 10am - 6pm
                    </Box>
                )}

                <Box mt={1.5} sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    paddingBottom: '4px'
                }}>
                    {/* <Button
                        variant="contained"
                        sx={{
                            backgroundColor: disabled ? '#ccc' : '#FF0083',
                            color: '#fff',
                            fontWeight: '400',
                            fontSize: '0.875rem',
                            textTransform: 'none',
                            padding: '6px 16px',
                            borderRadius: '5px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            '&:hover': { backgroundColor: disabled ? '#ccc' : '#e60073' },
                            fontFamily: 'Montserrat',
                            boxShadow: 'none',
                        }}
                        onClick={() => handleCombinedClick(method)}
                        disabled={disabled}
                    >
                        Choose
                        <img src={arrow_icon} alt="arrow icon" style={{ width: '8px', height: '8px', marginLeft: "7px" }} />
                    </Button> */}
                    {method === selectedMethod ? <button
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "0.2rem",
                            // border: "1.5px solid #FF0083",
                            padding: "0.4rem 1rem",
                            backgroundColor: "#FF0083",
                            borderRadius: "5px",
                            width: "40%",
                            cursor: "pointer"
                        }}
                        onClick={() => handleCombinedClick(method)}
                    >
                        <img src={tick} style={{ width: "1.2rem", height: "1.2rem" }} alt="Share Icon" />
                        <span
                            style={{
                                fontSize: "1rem",
                                fontFamily: "'Montserrat', sans-serif",
                                color: "white",
                                padding: "0.2rem",
                                cursor: "pointer",
                            }}
                        >
                            Selected
                        </span>
                    </button> : <button
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "0.2rem",
                            border: "1.5px solid #FF0083",
                            padding: "0.4rem 1rem",
                            backgroundColor: "white",
                            borderRadius: "5px",
                            width: "25%",
                            cursor: "pointer"
                        }}
                        onClick={() => handleCombinedClick(method)}
                    >
                        {/* <img src={share} style={{ width: "1rem", height: "1rem" }} alt="Share Icon" /> */}
                        <span
                            style={{
                                fontSize: "1rem",
                                fontFamily: "'Montserrat', sans-serif",
                                color: "#FF0083",
                                padding: "0.2rem",
                                cursor: "pointer",
                            }}
                        >
                            Select
                        </span>
                    </button>}

                    <div style={{ position: "relative" }}>
                        <ToastContainer />
                        <Dialog
                            open={openDialog}
                            // onClose={handleDialogClose}
                            maxWidth="150vw"
                            maxHeight="lg"
                            PaperProps={{
                                style: {
                                    width: dialogWidth,
                                    padding: "1.5rem 1rem",
                                    paddingBottom: "0.5rem",
                                    borderRadius: "4px",
                                    margin: "0px",
                                    height: "334px",
                                    zIndex: "999999"
                                },
                            }}
                        >
                            <DialogTitle
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    gap: "1rem",
                                    fontSize: "1.7rem",
                                    textAlign: "center",
                                    color: "black",
                                    padding: "2rem 0.6rem 1rem 0.6rem",
                                    fontWeight: "600",
                                    fontFamily: 'Barlow Condensed',
                                }}
                            >
                                {dialogSeverity === "success"
                                    ? "Audit created successfully"
                                    : "Error"}
                                <ShareAuditOptions auditUrl={reqUrl} />
                                <button
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "0.2rem",
                                        border: "1.5px solid #FF0083",
                                        padding: "0.2rem 1.2rem",
                                        backgroundColor: "white",
                                        borderRadius: "5px",
                                        width: "100%",
                                        cursor: "pointer"
                                    }}
                                    onClick={handleCopy}
                                >
                                    <img src={copy} style={{ width: "1rem", height: "1rem" }} alt="Share Icon" />
                                    <p
                                        style={{
                                            fontSize: "1rem",
                                            fontFamily: "'Montserrat', sans-serif",
                                            color: "#FF0083",
                                            padding: "0.5rem",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Copy url link
                                    </p>
                                </button>
                                <button
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "0.2rem",
                                        // border: "1.5px solid #FF0083",
                                        padding: "0.4rem 1rem",
                                        backgroundColor: "#FF0083",
                                        borderRadius: "5px",
                                        width: "40%",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => handleNavigate()}
                                >
                                    {/* <img src={tick} style={{ width: "1.2rem", height: "1.2rem" }} alt="Share Icon" /> */}
                                    <span
                                        style={{
                                            fontSize: "1rem",
                                            fontFamily: "'Montserrat', sans-serif",
                                            color: "white",
                                            padding: "0.2rem",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Continue
                                    </span>
                                </button>
                                {/* <button
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "0.2rem",
                                        border: "1.5px solid #FF0083",
                                        padding: "0.2rem 1.2rem",
                                        backgroundColor: "#ff0083",
                                        borderRadius: "5px",
                                        width: "100%",
                                        cursor: "pointer"
                                    }}
                                    onClick={handleCopy}
                                >
                                    <img src={copy} style={{ width: "1rem", height: "1rem" }} alt="Share Icon" />
                                    <p
                                        style={{
                                            fontSize: "1rem",
                                            fontFamily: "'Montserrat', sans-serif",
                                            color: "#FFFFFF",
                                            padding: "0.5rem",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Copy Link
                                    </p>
                                </button> */}
                            </DialogTitle>
                            {/* <IconButton
                                aria-label="close"
                                onClick={handleDialogClose}
                                sx={{
                                    position: "absolute",
                                    right: 14,
                                    top: 30,
                                    color: "black",
                                }}
                            >
                                <CloseIcon />
                            </IconButton> */}

                            {/* <div style={{ padding: "1rem 0.5rem 0.1rem" }}>
                                <p
                                    style={{
                                        color: "#FF0083",
                                        textDecoration: "underline",
                                        fontFamily: "'Montserrat', sans-serif",
                                        marginBottom: "2px",
                                        wordBreak: "break-word",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => window.open(reqUrl, "_blank")}
                                >
                                    {reqUrl}
                                </p>
                            </div> */}

                            <DialogContent style={{ padding: "0.5rem" }}>
                                {/* Additional content can go here */}
                            </DialogContent>
                        </Dialog>
                    </div>
                </Box>
            </CardContent>
        </Card>
    );
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div style={{ width: "100%" }}>
            {/* <img src={query_icon} className="question-div" alt="Help icon" /> */}
            <img
                src={query_icon}
                alt="Query Icon"
                className="question-div"
                onClick={handleClickOpen}
            />

            {/* Support Popup */}
            <Dialog open={open} onClose={handleClose} className="support-popup-dialog">
                <DialogContent className="support-popup-content">
                    <Support />
                    <button onClick={handleClose} className="close-btn">close</button>
                </DialogContent>
            </Dialog>
            <StepIndicator stepNumber={1} lineWidth="200px" />
            <Box sx={{ p: 3, maxWidth: 400, mx: 'auto', mt: '10px' }}>
                <Typography
                    variant="h6"
                    fontWeight="bold"
                    align="center"
                    fontFamily="Montserrat, sans-serif"
                    sx={{ mb: 0, fontSize: '14px', color: '#000000DE' }}
                >
                    Select method
                </Typography>

                <Typography
                    variant="h4"
                    fontWeight="600"
                    align="center"
                    fontFamily="Barlow Condensed"
                    textAlign={"center"}
                    sx={{ mb: 0, fontSize: '1.7rem', color: '#000000DE' }}
                >
                    To proceed choose self-inspection method
                </Typography>

                {renderCard('Video mode', 'Record video of your vehicle for self-inspection.', !isAvailable, 'video')}
                {renderCard('Photo mode', 'Take photos of your vehicle for self-inspection.', false, 'photo')}
                {renderCard('Hybrid mode', 'Take photo & video of your vehicle for self-inspection.', false, 'hybrid')}


            </Box>
            <div style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "center" }}>
                <button
                    disabled={!selectedMethod}
                    onClick={handleConfirm}
                    className="proceed-button-mode"
                    style={{
                        backgroundColor: selectedMethod ? "#FF0083" : "#dcdcdc",
                        color: selectedMethod ? "#ffffff" : "#0000003D",
                        cursor: selectedMethod ? "pointer" : "not-allowed",
                    }}
                >
                    Confirm
                </button>
            </div>
        </div>
    );
};

export default InspectionMethod;

